import { render, staticRenderFns } from "./_siteChangePost.vue?vue&type=template&id=62a1c601"
import script from "./_siteChangePost.vue?vue&type=script&lang=js"
export * from "./_siteChangePost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports